/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `website` - Website
 * * `agent` - Agent
 * * `broker` - Broker
 * * `ios` - iOS
 * * `android` - Android
 */
export enum DocumentSource {
  WEBSITE = 'website',
  AGENT = 'agent',
  BROKER = 'broker',
  IOS = 'ios',
  ANDROID = 'android',
}
